export var Status;
(function (Status) {
    Status["UNDETECTED"] = "UNDETECTED";
    Status["USE_AT_OWN_RISK"] = "USE_AT_OWN_RISK";
    Status["DETECTED"] = "DETECTED";
    Status["UPDATING"] = "UPDATING";
    Status["OUTDATED"] = "OUTDATED";
})(Status || (Status = {}));
